import type { MessageAttachment } from "@services/drybulkCargoOperationsApi";
import type { MessageApiResponse } from "@services/message-service/types";
import { MESSAGE_SENT_OPERATIONS, MESSAGE_SENT_SHIPPING_AGENT } from "../constants";
import { problemDetail } from "./problemDetail";

export type MessageRole = "OPERATIONS" | "SHIPPING_AGENT" | "SHIPPER";

const compareText = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0);

export const sortMessages = (messages: readonly MessageApiResponse[]): MessageApiResponse[] =>
  [...messages].sort(
    (a, b) =>
      compareText(a.creationDateTime ?? "", b.creationDateTime ?? "") || compareText(a.id, b.id),
  );

export const groupFilesByMessage = (
  files: readonly MessageAttachment[],
): Map<string, MessageAttachment[]> => {
  const grouped = new Map<string, MessageAttachment[]>();
  for (const file of files) {
    const list = grouped.get(file.messageId);
    if (list) {
      list.push(file);
    } else {
      grouped.set(file.messageId, [file]);
    }
  }
  grouped.forEach((list) =>
    list.sort((a, b) => compareText(a.uploadedAt ?? "", b.uploadedAt ?? "")),
  );
  return grouped;
};

export const messageNotificationTypes = (role: MessageRole): string[] => {
  switch (role) {
    case "SHIPPER":
      return [MESSAGE_SENT_SHIPPING_AGENT, MESSAGE_SENT_OPERATIONS];
    case "SHIPPING_AGENT":
      return [MESSAGE_SENT_OPERATIONS];
    default:
      return [MESSAGE_SENT_SHIPPING_AGENT];
  }
};

export const messageErrorText = (error: unknown): string | undefined => {
  const detail = problemDetail(error);
  if (detail) {
    return detail;
  }
  const message = (error as { response?: { data?: { message?: unknown } } } | null)?.response?.data
    ?.message;
  return typeof message === "string" && message.trim() !== "" ? message : undefined;
};
